<template>
  <video
    ref="videoRef"
    :src="props.src"
    :muted="props.muted"
    :loop="props.loop"
    :playsinline="props.playsinline"
    @timeupdate="$emit('timeupdate', $event)"
    @loadedmetadata="handleMetadata"
  ></video>
</template>

<script setup>
import {
  ref,
  onMounted,
  onUnmounted,
  defineProps,
  defineEmits,
  defineExpose,
} from 'vue'

const props = defineProps({
  src: { type: String, required: true },
  muted: { type: Boolean, default: true },
  loop: { type: Boolean, default: true },
  playsinline: { type: Boolean, default: true },
  autoplayVisible: { type: Boolean, default: true },
})

const emit = defineEmits(['timeupdate', 'loadedmetadata'])

const videoRef = ref(null)

const handleMetadata = event => {
  emit('loadedmetadata', event.target)
}

onMounted(() => {
  if (props.autoplayVisible && videoRef.value) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            videoRef.value.play()
          } else {
            videoRef.value.pause()
          }
        })
      },
      { threshold: 0.6 }
    )
    observer.observe(videoRef.value)

    onUnmounted(() => {
      observer.disconnect()
    })
  }
})

const play = () => videoRef.value?.play()
const pause = () => videoRef.value?.pause()
const seek = time => {
  if (videoRef.value) {
    videoRef.value.currentTime = time
  }
}

defineExpose({
  play,
  pause,
  seek,
  videoEl: videoRef,
})
</script>

<style scoped>
video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
